export enum UserPreferencesKeys {
    SEARCH_TERM = 'search-term',
    SORT_BY = 'sort-by',
    LIST_COLUMNS_ORDER = 'list-columns-order',
    LIST_COLUMNS_VISIBILITY = 'list-columns-visibility',
    LIST_RECORDS_PER_PAGE = 'list-records-per-page',
    LIST_PAGINATION_DISABLED = 'list-pagination-disabled',
    LIST_FILTERS_VISIBILITY = 'list-filters-visibility',
    LIST_CHOSEN_FILTER = 'list-chosen-filter',
    LIST_FILTERING_ENABLED = 'list-filtering-enabled',
}
